<script>
import { HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

Chart.defaults.scale.gridLines.display = false;

export default {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ["chartData", "titulo", "tickRange"],
  data() {
    return {
      options: {
        title: { 
          display: true,
          text: this.titulo
        },
        responsive: true,
        scales: {
          
          xAxes: [{            
            gridLines: { display: false },
            ticks: {
              min: - this.tickRange,
              max: this.tickRange, 
              callback: (val) =>   {
                      return Math.abs(Math.round(val));
              }              
            }
               }
                ],
                
          yAxes: [

            
            {
              
              stacked: true,
              display: true,
              ticks: {
                beginAtZero: false
              }
            }
          ]
        },
        hover: {
          mode: "nearest",
          intersect: true 
        },
        tooltips: {  
          
          callbacks: { 
            //he does not get the X values from here.
             label: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var total = dataset.data.reduce(function(
                previousValue,
                currentValue,
                currentIndex,
                array
              ) {
                return previousValue + currentValue;
              });
              var currentValue = Math.abs(dataset.data[tooltipItem.index]);
              var percentage = Math.abs(Math.floor((currentValue / total) * 100 + 0.5));
              return currentValue + " (" + percentage + "%)";
            }
          }
        },
        
        onClick: function clickHandler(evt) {
          var firstPoint = this.getElementAtEvent(evt)[0];

          if (firstPoint) {
            var label = this.data.labels[firstPoint._index];
            var value = this.data.datasets[firstPoint._datasetIndex].data[
              firstPoint._index
            ];

            evt.stopPropagation()

            document.dispatchEvent(
              new CustomEvent("openDay", {
                detail: label
              })
            );
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: () => {
      try {
        this.renderChart(this.chartData, this.options);
      } catch (error) {
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/charts/PyramidChart.vue